module.exports = __webpack_public_path__ + "img/icon_logo.4bd55c43.png";